import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F965BService {

  constructor(private http: HttpClient) { }

  loadF965BData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    // Use the correct endpoint for loading data (baseUrl already contains /gtw/)
    const url = `${baseUrl}/loadPivotFormJson`;

    // Merge params with global and filter parameters
    let requestParams = _.merge({}, globalService?.globalParams || {}, filterParams, params);

    // Build query string for GET request
    const queryParams = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== null && requestParams[key] !== undefined) {
        queryParams.set(key, requestParams[key].toString());
      }
    });

    const urlWithParams = `${url}?${queryParams.toString()}`;

    return this.http.get<any>(urlWithParams);
  }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters (Sch B SUCCESS PATTERN)
  saveF965BForm(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=gluccq`;

    // Get trans_type_key from first form data item (like AngularJS)
    const trans_type_key = formData[0]?.editrows?.[0]?.[0]?.trans_type_key || null;
    
    // 🚀 CRITICAL: Build AngularJS-compatible payload structure with ALL required fields
    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR || filterParams.tax_year,
      "scenario": rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": rowData.COMBINATION_KEY || filterParams.combination_key,
      "trans_type_key": trans_type_key,
      "scenarioCode": rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "",
      "is_issue_key_enabled": "N"
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(formData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    
    // Use process_name from workspace factory (like AngularJS)
    params.process_name = 'F965B Schedule B';
    params.combination_key = rowData.COMBINATION_KEY || filterParams.combination_key;
    params.trans_type_key = trans_type_key;
    
    // Add required fields as separate parameters (like Sch B does)
    params.tax_year = rowData.TAX_YEAR || filterParams.tax_year;
    params.scenario = rowData.SCENARIO || filterParams.scenario || "";
    params.jcd_key = rowData.JCD_KEY || filterParams.jcd_key || "";
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "";
    params.is_issue_key_enabled = "N";

    // 🚀 CRITICAL: Build checkLockedbj from rowData matching AngularJS format (Sch B pattern)
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add other required fields from rowData
    if (rowData.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
